// extracted by mini-css-extract-plugin
export default {"detailsContainer":"ProjectDetails_detailsContainer__gpDSQ","details":"ProjectDetails_details__4R6W6","links":"ProjectDetails_links__9-gpf","stack":"ProjectDetails_stack__E0LW8"};